import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from '@app/env';
import { getTranslationProviders } from './i18n-providers';

import { AppModule } from './app.module';

if (environment.production) {
  enableProdMode();
}

if (!environment.production) {
  // when bootstraping a local build, then add translation providers
  getTranslationProviders().then(function(providers) {
    const bootstrapOptions = { providers };
    bootstrapNow(bootstrapOptions);
  });
} else {
  // when bootstraping a test/prod build translations files are added as build parameters for --aot
  bootstrapNow();
}

// required for IE support (DIET-348)
if (!Array.prototype.includes) {
  Array.prototype.includes = function(search) {
    return this.indexOf(search) !== -1;
  };
}

/*
    In separate function to bypass angularCLI bootstraping bug https://github.com/angular/angular-cli/issues/3540
 */
function bootstrapNow(options?) {
  platformBrowserDynamic()
    .bootstrapModule(AppModule, options || {})
    .then(ref => {});
}
